import uniqid from 'uniqid'
import { toast, cssTransition } from 'react-toastify'

import {
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_INFO,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_UPSELL,
} from './Toast.js'

const toastOptionsDefault = {
  position: toast.POSITION.TOP_RIGHT,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  bodyClassName: 'c-toast__body',
  icon: false,
  transition: cssTransition({
    enter: 'c-toast--enter',
    exit: 'c-toast--exit',
    duration: [750, 750],
  }),
}

/**
 * Dismiss a previously showed Toast
 * @param {string} source unique identifier for the toast to dismiss
 */
export const toastDismiss = (source) => {
  toast.dismiss(source)
}

/**
 * Show a Toast
 * @param {string} text Content of the Toast
 * @param {string} variant Toast variant, can be `success`, `warning`, `info`, `error`
 * @param {string} source Unique identifier for the toast to show
 * @param {boolean} dismissOnBlur Whether or not the Toast should dismiss on click on other DOM elements
 * @returns {string} The unique identifier for the showed Toast
 */
export const toastShow = (
  text,
  variant,
  source,
  dismissOnBlur,
  closeButton,
  position,
) => {
  setTimeout(() => {
    const toastId = source || uniqid('c-toast')

    const toastOptions = {
      ...toastOptionsDefault,
      closeButton,
      toastId,
      autoClose: variant === TOAST_VARIANT_SUCCESS ? 5000 : false,
      position,
    }

    function onBlur() {
      // console.log('dismiss on blur', toastId)
      toast.dismiss(toastId)
      document.removeEventListener('click', onBlur)
    }

    if (dismissOnBlur) {
      document.addEventListener('click', onBlur)
    }

    if (toast.isActive(toastId)) {
      toast.dismiss(toastId)
    }

    switch (variant) {
      case TOAST_VARIANT_SUCCESS:
        console.log('###toastOptions', toastOptions)
        return toast.success(text, {
          ...toastOptions,
          className: 'c-toast c-toast--success',
        })
      case TOAST_VARIANT_WARNING:
        return toast.warning(text, {
          ...toastOptions,
          className: 'c-toast c-toast--warning',
        })
      case TOAST_VARIANT_INFO:
        return toast.info(text, {
          ...toastOptions,
          className: 'c-toast c-toast--info',
        })
      case TOAST_VARIANT_ERROR:
        return toast.error(text, {
          ...toastOptions,
          className: 'c-toast c-toast--error',
        })
      case TOAST_VARIANT_UPSELL:
        return toast.warning(text, {
          ...toastOptions,
          className: 'c-toast c-toast--promo',
        })
      default:
        return toast.info(text, { ...toastOptions, className: 'c-toast' })
    }
  }, 100)
}
